const getFirstQueryString = (query: string | string[]): string => {
  return Array.isArray(query) ? (query.length ? query[0] : '') : query
}

export default getFirstQueryString
